// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const apiPath = (): string => {
    const { hostname, protocol } = window.location;
    
    const getEnvironmentType = () => {
        if(hostname.includes('dev')) return 'dev';
        if(hostname.includes('qa')) return 'qa';
        if(hostname.includes('model')) return 'model';
        if(hostname.includes('ceps')) return 'ceps';
        if(hostname.includes('edge')) return 'qa';
        if(hostname.includes('integration-model')) return 'integration';
        return 'production';
    }

    const apiUrls = {
        dev: '//dev-espp-api.epgins.com',
        qa: '//espp-api-qa.epgins.com',
        model: '//espp-api-model.epgins.com',
        ceps: '//ceps-espp-api.assurant.com',
        production: '//espp-api.epgins.com',
        integration: '//espp-api-integration-model.epgins.com'
    }

    return protocol + apiUrls[getEnvironmentType()];
}

export const environment = {
    name: 'production',
    production: false,
    //esppApiBase: window.location.hostname === 'localhost'? 'https://dev-espp-api.epgins.com' :  window.location.hostname == 'espp-dev.epgins.com'? 'https://espp-api-dev.epgins.com' : 'https://espp-api.epgins.com'
    esppApiBase: apiPath(),
    versionCheckIntervalMs: 60 * 60 * 1000
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.